// eslint-disable-next-line
__webpack_public_path__ =
  window.process.env.NODE_ENV === 'production' && window.__SERVER_DATA__.config.resourceBasePath
    ? `${window.__SERVER_DATA__.config.resourceBasePath}`
    : '';
